import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PipesModule } from '@draeger-academy/common';
import { TranslateModule } from '@ngx-translate/core';
import { HubspotFormBoxModule } from '../hubspot-form-box';
import { DaButtonModule } from '../da-button';
import { DaLinkModule } from '../da-link';
import { DaProgressiveImageModule } from '../da-progressive-image';
import { ShowMoreModule } from '../show-more';
import { ContactUsSectionComponent } from './contact-us-section.component';

@NgModule({
    declarations: [ContactUsSectionComponent],
    exports: [ContactUsSectionComponent],
    imports: [
        CommonModule,
        PipesModule,
        DaLinkModule,
        DaButtonModule,
        DaProgressiveImageModule,
        ShowMoreModule,
        TranslateModule,
        HubspotFormBoxModule
    ],
    providers: []
})
export class ContactUsSectionModule {}
